export default "__VITE_ASSET__2034ec2e__"